// extracted by mini-css-extract-plugin
export default {"AdminMiniItemGrid":"styles_AdminMiniItemGrid__7qM6Z","color":"styles_color__47LMf","text":"styles_text__CS7-I","deleteBtn":"styles_deleteBtn__QCiu4"};